import React from 'react';
import { useSelector } from 'react-redux';
import { Spin, Card, message } from 'antd';
import { gql, useMutation, useQuery } from '@apollo/client';

import EmployeeBulkInsert from '../../components/Employee/EmployeeBulkInsert';
import {
  DESIGNATIONS_OPTION_QUERY,
  LOCATIONS_OPTIONS_QUERY,
  PORTFOLIO_OPTIONS_QUERY,
  PRODUCT_TYPE_OPTIONS_QUERY,
  STAGE_OPTIONS_QUERY,
} from '../../apollo/queries';
import { EMPLOYEE_ALL_FIELDS } from '../../apollo/fragments';

import * as Config from '../../appConfig';

const EMPLOYEE_BULK_IMPORT_QUERY = gql`
  ${EMPLOYEE_ALL_FIELDS}
  mutation EmployeeBulkInsert($input: [BulkInsertEmployeeInput]) {
    addEmployeeBulk(input: $input) {
      ...EmployeeFields
    }
  }
`;

const EmployeeBulkImporter = () => {
  const { user } = useSelector((state) => state.login);

  const { loading: loadingD, data: designations } = useQuery(
    DESIGNATIONS_OPTION_QUERY
  );
  const { loading: loadingR, data: locations } = useQuery(
    LOCATIONS_OPTIONS_QUERY,
    {
      variables: {
        userId: user.id,
      },
    }
  );
  const { loading: loadingP, data: portfolios } = useQuery(
    PORTFOLIO_OPTIONS_QUERY
  );
  const { loading: loadingPoductType, data: productTypes } = useQuery(
    PRODUCT_TYPE_OPTIONS_QUERY
  );
  const { loading: loadingStage, data: stages } = useQuery(STAGE_OPTIONS_QUERY);

  const [addEmployeeBulk, { loading: bulkInsertLoading }] = useMutation(
    EMPLOYEE_BULK_IMPORT_QUERY
  );

  const onSave = (values, keys, callBack) => {
    console.log('onSave called with ///', values, keys);
    const input = keys.map((key) => {
      return {
        first_name: values.first_name[key],
        last_name: values.last_name[key],
        location_id: parseInt(values.location[key][1]),
        designation_id: parseInt(values.designation[key]),
        portfolio_id: parseInt(values.portfolio[key]),
        product_type_id: parseInt(values.productType[key]),
        stage_id: parseInt(values.stage[key]),
        aadhar: values.aadhar[key],
        pan: values.pan[key],
        phone_1: values.phone_1[key],
        phone_2: values.phone_2[key],
        email: values.email[key],
        date_of_joining: values.date_of_joining[key].format(
          Config.DATE_FORMAT_SERVER
        ),
        address_1: values.address_1[key],
        address_2: values.address_2[key],
        city: values.city[key],
        state: values.state[key],
        pin_code: values.pin_code[key],
        bank_name: values.bank_name[key],
        account_number: values.account_number[key],
        branch: values.branch[key],
        ifsc_code: values.ifsc_code[key],
        card_number: values.card_number[key],
        card_validity_end:
          values.card_number && values.card_validity_end[key]
            ? values.card_validity_end[key].format(Config.DATE_FORMAT_SERVER)
            : null,
        dra_number: values.dra_number[key],
        dra_training_start:
          values.dra_number &&
          values.dra_training_period[key] &&
          values.dra_training_period[key][0]
            ? values.dra_training_period[key][0].format(
                Config.DATE_FORMAT_SERVER
              )
            : null,
        dra_training_end:
          values.dra_number &&
          values.dra_training_period[key] &&
          values.dra_training_period[key][1]
            ? values.dra_training_period[key][1].format(
                Config.DATE_FORMAT_SERVER
              )
            : null,
        dra_status: values.dra_status[key],
        pvc_number: values.pvc_number[key],
        pvc_validity_end:
          values.pvc_number && values.pvc_validity_end[key]
            ? values.pvc_validity_end[key].format(Config.DATE_FORMAT_SERVER)
            : null,
        rac_mobility_id: values.rac_mobility_id[key],
        cc_mobility_id: values.cc_mobility_id[key],
        did_number: values.did_number[key],
        provider: values.provider[key],
        policy_start_date:
          values.policy_period &&
          values.policy_period[key] &&
          values.policy_period[key][0]
            ? values.policy_period[key][0].format(Config.DATE_FORMAT_SERVER)
            : null,
        policy_end_date:
          values.policy_period &&
          values.policy_period[key] &&
          values.policy_period[key][1]
            ? values.policy_period[key][1].format(Config.DATE_FORMAT_SERVER)
            : null,
        type: values.type[key],
        sum_insured: values.sum_insured[key],
        date_of_relieving:
          values.date_of_relieving[key] &&
          values.date_of_relieving[key].format(Config.DATE_FORMAT_SERVER),
        reference_name: values.reference_name[key],
        reference_contact: values.reference_contact[key],
      };
    });

    addEmployeeBulk({
      variables: {
        input: input,
      },
    })
      .then(({ data: { addEmployeeBulk: employees } }) => {
        console.log('addEmployeeBulk done', employees);
        if (employees) {
          message.success('Employees added successfully!');
        }
        callBack(true);
      })
      .catch((e) => {
        console.log('mutationError ////', e, e.graphQLErrors);
        let error = '';
        if (e.graphQLErrors) {
          e.graphQLErrors.forEach(({ extensions, message }) => {
            const { category, validation } = extensions;
            if (category === 'validation') {
              error = Object.keys(validation).map((field) => {
                return (
                  <div>
                    Row #{parseInt(field.split('.')[1]) + 1}:{' '}
                    {validation[field][0].replace('input.', '')}
                  </div>
                );
              });
            } else {
              error = message;
            }
          });
        }
        message.error(
          error ? error : 'Some error occured, Please try again !!!'
        );
        callBack(false);
      });

    console.log('input ///', input);
  };

  return (
    <Spin
      spinning={
        loadingD ||
        loadingR ||
        loadingP ||
        loadingPoductType ||
        loadingStage ||
        bulkInsertLoading
      }
    >
      <Card style={{ minHeight: '200px', borderTop: '0' }}>
        <EmployeeBulkInsert
          locations={locations ? locations.locations : []}
          designations={designations ? designations.designations : []}
          portfolios={portfolios ? portfolios.portfolios : []}
          productTypes={productTypes ? productTypes.productTypes : []}
          stages={stages ? stages.stages : []}
          onSave={onSave}
        />
      </Card>
    </Spin>
  );
};

export default EmployeeBulkImporter;
